import React from "react";
import phoneImg from "../assets/contorlgame.png";

function FeaturesSection() {
  return (
    <section className="platform-section">

        <h2 className="section-heading">
          What Makes KaalBet Online India’s Legal Cricket Betting Platform
        </h2>

        <div className="platform-container">

          {/* LEFT IMAGE */}
          <div className="platform-left">
            <img src={phoneImg} alt="big win mobile" />
          </div>

          {/* RIGHT CONTENT */}
          <div className="platform-right">

            <p>
              The betting field is crowded with sites that are making great
              claims, but the KaalBet Online is a power that can be seen and
              heard. What makes us different from other Online Cricket ID
              platforms is its focus on transparency, user security, and
              customer satisfaction.
            </p>

            <p>
              Are you interested in creating your
              <span className="highlight"> Cricket Master ID online </span>
              and becoming a part of sports exchange gaming? You are in the
              right place.
            </p>

            <h3>Over 1 Million Real Bettors & Casino Players</h3>

            <p>
              Having a community of one million people playing daily, KaalBet
              Online is one of the liveliest gaming communities in India. The
              higher the activity, the greater the fun and the more chances
              to win.
            </p>

            <h3>More Than 5000 Games</h3>

            <p>
              KaalBet Online allows you to experience a whole system of
              entertainment under one login. From the most popular betting on
              cricket and football to the live casino with mega slots, Teen
              Patti, Andar Bahar, and the VIP tables.
            </p>

            <h3>India’s Trusted Cricket Betting & Casino Platform</h3>

            <p>
              The KaalBet Online has won the trust of players all over the
              country and has become the leading place in India for cricket
              betting, live casinos, slots, and premium gaming offering
              unrivaled variety, dependability, and constant entertainment.
            </p>

            <h3>Quick Payout Processing</h3>

            <p>
              Winning is even more pleasurable when you get immediate access
              to your cash. Our reliable online betting ID system has a
              withdrawal request processing time of 2-4 hours on average,
              with even faster payments for many customers.
            </p>

            <h3>Wide Range Of Market Coverage</h3>

            <p>
              Your cricket satta ID provider covers everything from traditional
              match outcome betting to advanced options like player
              performance, over/under, and live in-play gambling.
            </p>

            <h3>User-Friendly Interface</h3>

            <p>
              Our platform comes with a very user-friendly design that
              completely removes the hassle of searching for matches,
              placing bets, and managing your account.
            </p>

            <h3>Responsible Betting Tools</h3>

            <p>
              Your reliable online cricket ID has all the necessary features
              for managing deposit limits, betting limits, and self-exclusion.
              With such features, you are in control and make sure that betting
              is still fun and not a financial burden.
            </p>

             <a
        href="https://wa.link/haljko"
        
        target="_blank"
        rel="noreferrer"
      >
         <button className="cta-button">
          Whatsapp to get online cricket ID
        </button>
      </a>

          </div>

        </div>

      </section>
  );
}

export default FeaturesSection;